<template>
  <div class="filter-row">
    <div class="title">{{ props.title }}</div>
    <div class="filter">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  interface FilterRowProps {
    title?: string;
  }

  const props = defineProps<FilterRowProps>();
</script>

<style scoped lang="scss">
  @use '@experience/design-tokens/typography' as typography;

  .filter-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .title {
    @include typography.base-400-400-semi;
  }
</style>
